import { BrowserModule } from '@angular/platform-browser';
//import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SupportInfoComponent } from './layouts/support-Info/support-info/support-info.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { FormsComponent } from './modules/forms/forms.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './modules/login/login.component';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {OverlayModule} from '@angular/cdk/overlay';
import { LoginModule } from './modules/login/login.module';
import { FormsDeclarationModule } from './modules/forms/forms.module';
import { LayoutCustomModule } from './layouts/layout.module';
import { ModalModule } from 'ngx-bootstrap/modal';  
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { SharingService } from './modules/shared/shared.service';
import { DashboardHeaderComponent } from './modules/dashboard/components/dashboard-header/dashboard-header.component';
import { DashboardPopupComponent } from './modules/dashboard/components/dashboard-popup/dashboard-popup';
import { HttpClientModule } from '@angular/common/http';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { CustomSpinnerComponent } from './shared/components/custom-spinner/custom-spinner.component';
import { NumberFormatPipe } from './shared/number.pipe';
 
@NgModule({
  declarations: [
    AppComponent,
    SupportInfoComponent,
    DashboardComponent,
    NumberFormatPipe,
    DashboardHeaderComponent,
    FormsComponent,
    LoginComponent,
    DashboardPopupComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    LoginModule,
    ModalModule.forRoot(),
    LayoutCustomModule,
    FormsDeclarationModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    OverlayModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgHttpLoaderModule.forRoot(),
    
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [SharingService, DatePipe,NumberFormatPipe],
  bootstrap: [AppComponent],
  entryComponents: [CustomSpinnerComponent],
  exports: [ NumberFormatPipe]
})
export class AppModule { }


// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  const Languagepath = 'api/translation/';
  const getlangurl = environment.apiURL + Languagepath;
  return new TranslateHttpLoader(http, getlangurl, '');
}
